(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");

		sliders.forEach((slider, index) => {
			const productSlider = new Swiper(slider, {
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: ".product-button-group .swiper-button-next",
					prevEl: ".product-button-group .swiper-button-prev",
				},
				allowTouchMove: true,
				breakpoints: {
					990: {
						allowTouchMove: false,
					},
				},
			});

			// Assicurati che l'immagine sia cliccabile
			const productImages = slider.querySelectorAll('.swiper-slide .product-link');
			productImages.forEach((imageLink) => {
				imageLink.addEventListener('click', function (event) {
					// Puoi aggiungere logica qui se necessario
					// Ma generalmente il link dovrebbe funzionare senza dover prevenire l'evento
				});
			});
		});
	};

	initSlider();

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
